import { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from '@/utils/classNames.ts';
import { OtpInput as OtpInputBase } from '@/components/functional/OtpInput/OtpInputBase';
import { InputProps } from 'react-daisyui';

type OtpInputProps = ComponentPropsWithoutRef<typeof OtpInputBase> & {
  label?: string;
  error?: string;
  wrapperClassName?: string;
  inputClassName?: string;
} & Pick<InputProps, 'color'>;

const OtpInput: FC<OtpInputProps> = ({ wrapperClassName, label, error, inputClassName, color, ...args }) => {
  return (
    <div className={cn('form-control max-w-full w-full', wrapperClassName)}>
      {label ? (
        <label className="label">
          <span className="label-text">{label}</span>
        </label>
      ) : null}
      <OtpInputBase
        inputClassName={cn(
          'input input-bordered mx-1 w-full h-[56px]',
          {
            'input-ghost': color === 'ghost',
            'input-primary': color === 'primary',
            'input-secondary': color === 'secondary',
            'input-accent': color === 'accent',
            'input-info': color === 'info',
            'input-success': color === 'success',
            'input-warning': color === 'warning',
            'input-error': !!error || color === 'error',
          },
          inputClassName
        )}
        {...args}
      />
      {error ? (
        <label className="label">
          <span className="label-text-alt text-error">{error}</span>
        </label>
      ) : null}
    </div>
  );
};

export default OtpInput;
